import React, { useState } from "react";
import { Trash2, Trash, X } from "lucide-react";
import StyledLoadingSpinner from "./ui/StyledLoadingSpinner";
import { DeleteModalProps } from "../types/deleteModal";

export const DeleteModal: React.FC<DeleteModalProps> = ({
  onConfirm,
  title = "Delete Confirmation",
  description = "Are you sure you want to delete this item? This action cannot be undone.",
  icon = <Trash2 className="w-6 h-6 text-red-600" />,
  buttonText = "",
  buttonIcon = <Trash size={16} />,
  isDeleting = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  return (
    <>
      <button onClick={() => setIsOpen(true)} className={props.buttonClassName || "btnDanger iconBtn"}>
        {buttonIcon}
        {buttonText && <span>{buttonText}</span>}
      </button>
      {isDeleting && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <StyledLoadingSpinner />
        </div>
      )}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full relative">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            >
              <X className="w-5 h-5" />
            </button>
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="bg-red-100 p-3 rounded-full">{icon}</div>
              <h4 className="text-xl font-semibold">{title}</h4>
              <p className="text-sm text-gray-600">{description}</p>
              <div className="flex gap-4 mt-4">
                <button
                  onClick={() => setIsOpen(false)}
                  className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirm}
                  className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
